export const isMobile = () => window.innerWidth <= 720;



// WEBPACK FOOTER //
// ./src/store/getters.js